import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "manual-installation"
    }}>{`Manual installation`}</h3>
    <p>{`First, add `}<inlineCode parentName="p">{`posthog_flutter`}</inlineCode>{` to your `}<inlineCode parentName="p">{`pubspec.yaml`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml",
        "metastring": "file=pubspec.yaml",
        "file": "pubspec.yaml"
      }}>{`# rest of your code

dependencies:
  flutter:
    sdk: flutter
  posthog_flutter: ^5.0.0

# rest of your code
`}</code></pre>
    <p>{`Then complete the manual setup for each platform:`}</p>
    <h4 {...{
      "id": "android-setup"
    }}>{`Android setup`}</h4>
    <p>{`Add your PostHog configuration to your `}<inlineCode parentName="p">{`AndroidManifest.xml`}</inlineCode>{` file located in the `}<inlineCode parentName="p">{`android/app/src/main`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "file=android/app/src/main/AndroidManifest.xml",
        "file": "android/app/src/main/AndroidManifest.xml"
      }}>{`<manifest xmlns:android="http://schemas.android.com/apk/res/android" package="your.package.name">
    <application>
        <!-- ... other configuration ... -->
        <meta-data android:name="com.posthog.posthog.AUTO_INIT" android:value="false" />
    </application>
</manifest>
`}</code></pre>
    <p>{`You'll also need to update the minimum Android SDK version to `}<inlineCode parentName="p">{`21`}</inlineCode>{` in `}<inlineCode parentName="p">{`android/app/build.gradle`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-gradle_kotlin",
        "metastring": "file=android/app/build.gradle",
        "file": "android/app/build.gradle"
      }}>{`// rest of your config

    defaultConfig {
        minSdkVersion 21
        // rest of your config
    }

// rest of your config
`}</code></pre>
    <h4 {...{
      "id": "ios-setup"
    }}>{`iOS setup`}</h4>
    <p>{`Add your PostHog configuration to the `}<inlineCode parentName="p">{`Info.plist`}</inlineCode>{` file located in the `}<inlineCode parentName="p">{`ios/Runner`}</inlineCode>{` directory:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml",
        "metastring": "file=ios/Runner/Info.plist",
        "file": "ios/Runner/Info.plist"
      }}>{`<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE plist PUBLIC "-//Apple//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd">
<plist version="1.0">
<dict>
    <!-- rest of your configuration -->
    <key>com.posthog.posthog.AUTO_INIT</key>
    <false/>
</dict>
</plist>
`}</code></pre>
    <p>{`You'll need to set the minimum platform version to iOS 13.0 in your Podfile:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml",
        "metastring": "file=ios/Podfile",
        "file": "ios/Podfile"
      }}>{`platform :ios, '13.0'

# rest of your config
`}</code></pre>
    <h4 {...{
      "id": "dart-setup"
    }}>{`Dart setup`}</h4>
    <p>{`Then setup the SDK manually:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`import 'package:flutter/material.dart';

import 'package:posthog_flutter/posthog_flutter.dart';

Future<void> main() async {
  // init WidgetsFlutterBinding if not yet
  WidgetsFlutterBinding.ensureInitialized();
  final config = PostHogConfig('<ph_project_api_key>');
  config.debug = true;
  config.captureApplicationLifecycleEvents = true;
  // or EU Host: 'https://eu.i.posthog.com'
  config.host = 'https://us.i.posthog.com';
  await Posthog().setup(config);
  runApp(MyApp());
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      